<div class="text-justify container border-bottom">
  <h1>تماس با ما</h1>
  <hr />
  جهت تماس با شرکت <b>کاوشگر کیان کارپیشه (سهامی خاص)</b> با یکی از روش‌های زیر اقدام بفرمایید
  <div>
    <label class="form-group group-box mb-0">
      <span>تلفن و واتس‌اپ: </span>
      <span class="m-0 fs-lg" dir="ltr">
        <i class="fa fa-phone text fs-xxl"></i>&nbsp;&nbsp;021-28429921</span>
      </label>
      <div class="f-red fs-sm mb-3 text-left">
        لطفا فقط با پیش‌شماره 021 تماس بگیرید. 
      </div>
    <label class="form-group group-box">
      <span>ای-میل: </span>
      <span class="m-0" dir="ltr">
        <i class="fa fa-envelope text fs-xxl"></i>&nbsp;&nbsp;info@karpishe.com</span>
    </label>
    <label class="form-group group-box">
      <span>لینکداین: </span>
      <a dir="ltr" class="m-0" title="لینکداین کارپیشه" href="https://www.linkedin.com/company/karpishe"
        target="_blank">
        <i class="fab fa-linkedin text fs-xxl"></i>&nbsp;&nbsp;company/karpishe</a>
    </label>
    <label class="form-group group-box">
      <span>اینستاگرام: </span>
      <a dir="ltr" class="m-0" title="اینستاگرام کارپیشه" href="https://www.instagram.com/karpisheh/" target="_blank">
        <i class="fab fa-instagram text fs-xxl"></i>&nbsp;&nbsp;@karpisheh</a>
    </label>
    <label class="form-group group-box">
      <span>تلگرام: </span>
      <a dir="ltr" class="m-0" title="کانال تلگرام کارپیشه" href="https://t.me/estekhtam_channel" target="_blank">
        <i class="fab fa-telegram-plane text fs-xxl"></i>&nbsp;&nbsp;@estekhtam_channel</a>
    </label>
    <label class="form-group group-box">
      <span>تویتر: </span>
      <a dir="ltr" class="m-0" title="تویتر کارپیشه" href="https://twitter.com/karpisheco" target="_blank"><i
          class="fab fa-twitter text fs-xxl"></i>&nbsp;&nbsp;@karpisheco</a>
    </label>
    <label class="form-group group-box">
      <span>آدرس: </span>
      <span class="m-0" dir="ltr">
        <i class="fa fa-map-marker-alt text fs-xxl"></i>&nbsp;&nbsp;تهران، دانشگاه علم و صنعت ایران، مرکز نوآوری
        نیترو</span>
    </label>
  </div>
</div>